export const setMarkupType = (value) => {
  return {
    type: 'SET_MARKUP_TYPE',
    value
  }
}

export const setCurrency = (value) => {
  return {
    type: 'SET_CURRENCY',
    value
  }
}

export const toggleDisplayCart = () => {
  return {
    type: 'TOGGLE_DISPLAY_CART'
  }
}

export const showCart = () => {
  return {
    type: 'SET_DISPLAY_CART',
    value: true
  }
}

export const setExchangeRate = (value) => {
  return {
    type: 'SET_EXCHANGE_RATE',
    value
  }
}

export const showPreferences = () => {
  return {
    type: 'OPEN_MODAL',
    value: 'preferences'
  }
}

export const closePreferences = () => {
  return {
    type: 'CLOSE_MODAL'
  }
}



// WEBPACK FOOTER //
// ./src/actions/settings.js